module.exports = __webpack_public_path__ + "static/img/xxzxyjxx1.26ddddf9.png";